import { ChannelPhase } from '@frontend/data-access';
import { Draggable } from '@hello-pangea/dnd';

import { Typography } from 'antd';
import KanbanList from '../list';

export type ColumnType = {
  index: number;
  data: ChannelPhase;
};

const { Text } = Typography;

const KanbanColumn = ({ index, data }: ColumnType) => {
  return (
    <Draggable
      index={index}
      key={data.phase.id}
      draggableId={`${data.phase.id}`}
      isDragDisabled={true}
    >
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          className={`bg-gray-100 border border-gray-400 rounded-lg px-2 py-4 max-w-[282px]`}
        >
          <div className="flex flex-col gap-4 min-w-56 h-full">
            <div {...provided.dragHandleProps} className="px-2 space-x-1">
              <Text>{data.phase.title}</Text>
              <span className="text-gray-700">({data.ideas?.total || 0})</span>
            </div>
            <KanbanList
              id={data.phase.id}
              items={data.ideas?.items || []}
              total={data.ideas?.total}
            />
          </div>
        </div>
      )}
    </Draggable>
  );
};

export default KanbanColumn;
